import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'

import StyledTable from '@components/StyledTable'
import { formatDate, formatDateTime } from '@util/date-util'

import { SidebarLayoutDrawer } from '../../../theme/components/SidebarLayoutDrawer'
import type { Subproces } from '../types/Subproces'
import { getStatusLabelForType } from '../util/subproces-util'

const headerCells = [
  { id: 'date', numeric: false, label: 'Datum', fixed: 160 },
  { id: 'status', numeric: false, label: 'Status' },
  { id: 'dueDate', numeric: false, label: 'Opleverdatum' },
  { id: 'email', numeric: false, label: 'Door' },
]

export const SubprocesLog = ({
  subproces,
  onClose,
  open,
}: {
  subproces: Subproces
  onClose: () => void
  open: boolean
}) => {
  const { log = [] } = subproces

  return (
    <SidebarLayoutDrawer
      open={open}
      onClose={onClose}
      title={`Log van subproces ${subproces.type}`}
    >
      <StyledTable headerCells={headerCells} {...({} as any)}>
        {log.map((logEntry) => {
          const isRejected = logEntry.status === 'rejected'

          return (
            <TableRow key={`${logEntry.date}-${logEntry.organisatie}`}>
              <TableCell>{formatDateTime(logEntry.date)}</TableCell>
              <TableCell>
                {getStatusLabelForType(subproces.type, logEntry.status)}

                {isRejected && (
                  <>
                    <br />
                    <Typography variant="caption">Na afkeuring</Typography>
                  </>
                )}

                {logEntry.text && (
                  <>
                    <br />
                    <Typography variant="caption">{logEntry.text}</Typography>
                  </>
                )}
              </TableCell>
              <TableCell>
                {logEntry.dueDate && formatDate(logEntry.dueDate)}
                {logEntry.dueDate && logEntry.schouwDatum && <br />}
                {logEntry.schouwDatum &&
                  `Schouw uitgevoerd op ${formatDate(logEntry.schouwDatum)}`}
              </TableCell>
              <TableCell>
                {logEntry.organisatie}

                {logEntry.email ? (
                  <Typography variant="caption">
                    <br />
                    {logEntry.email}
                  </Typography>
                ) : (
                  ''
                )}
              </TableCell>
            </TableRow>
          )
        })}
      </StyledTable>
    </SidebarLayoutDrawer>
  )
}
